import {
    Box,
    useTheme,
    Typography,
    Switch,
    Button,
    TextField,
    useMediaQuery,
} from "@mui/material";
import logo from "../../assets/buzz.png";
// import mark from "../../assets/mark.jpg";
import enabledlocation from "../../assets/enabledlocation.svg";
import male from "../../assets/maleinstant.svg";
import { width } from "@mui/system";

import {
    GoogleMap,
    InfoWindow,
    InfoWindowF,
    Marker,
    MarkerF,
    useLoadScript,
} from "@react-google-maps/api";
import React, { useMemo, useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { tokens } from "../../Theme/theme";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { Header } from "../global/Header";
import { Add, ArrowBackIosNewRounded, ArrowDownwardRounded, ArrowDropUp, ArrowOutward, ArrowOutwardRounded, ArrowRightAltRounded, CameraAltOutlined, EditOutlined, KeyboardArrowRight, MovingRounded, NotificationAdd, OnlinePredictionRounded, PeopleAltRounded, PeopleOutlineRounded, Person2Rounded, StarRateRounded, SwipeRight } from "@mui/icons-material";
import '../Users/MapStyle.css'
import BASE_URL from "../../NetworkConfig/ApiConfig";
import CustomCarousel from "../Utils/CustomSlider";
import MultiPartFormPopup from "../Utils/MultiPartFormPopup";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import PopupDeleteConfirmation from "../Utils/PopupDeleteConfirmation";
import MultiPartNoticeboardReplacePopup from "../Utils/MultiPartNoticeboardReplacePopup";
import CommunityNotificationSendPopup from "../Utils/CommunityNotificationSendPopup";
import EditCommunityPopup from "../Utils/EditCommunityPopup";
import { ArrowRightIcon } from "@mui/x-date-pickers";
import { ResponsiveLine } from '@nivo/line'
import { linearGradientDef } from "@nivo/core";

function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const CommunityDetail = () => {

    const theme = useTheme();
    const query = useQuery()
    const navigate = useNavigate()
    const colors = tokens(theme.palette.mode);
    const [communityDetail, setCommunityDetail] = useState({})
    const [communityBasics, setCommunityBasics] = useState({})
    const [openNoticeboardForm, setOpenNoticeBoardForm] = useState(false);
    const [openNoticeboardReplaceForm, setOpenNoticeBoardReplaceForm] = useState(false);
    const [noticeboardSlideToReplace, setNoticeboardSlideToReplace] = useState({})
    const [openDeleteNoticeboardPopup, setDeleteNoticeboardPopup] = useState(false)
    const [currentSelectedNoticeboardSlide, setCurrentSelectedNoticeboardSlide] = useState({})
    const [currentMarketplacebanner, setCurrentMarketplaceBanner] = useState({})
    const [showMarketplaceDeletePopup, setShowMarketplaceDeletePopup] = useState(false)
    const [showNotificationShowPopup, setShowNotificationShowPopup] = useState(false)
    const [userProfile, setUserProfile] = useState({})
    const [showEditPopup, setShowEditPopup] = useState(false)
    const [contentGraphData, setContentGraphData] = useState([])
    const [activeByDuration, setActiveByDuration] = useState([])
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")


    const Convert_Time_Zone = (isostring) => {
        const isoString = isostring;
        const desiredFormat = "dd MMMM yyyy, hh:mm:ss a";

        const indianTimeZone = "Asia/Kolkata";
        const zonedTime = utcToZonedTime(isoString, indianTimeZone);

        const formattedDate = format(zonedTime, desiredFormat, {
            timeZone: indianTimeZone,
        });

        return formattedDate;
    };

    const FetchCommunityDetail = async () => {
        // setloading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/community/getbyid/${query.get('community')}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();

        console.log(data)
        if (data.success === true) {
            setCommunityBasics(data.response.community)
            setCommunityDetail(data.response);
            FetchGraphData()
            // setloading(false);
        }

    };


    // const FetchUserGraphData = async (startDate, endDate) => {

    //     console.log(startDate, endDate)
    //     // setloading(true);
    //     const token = localStorage.getItem("token");
    //     const response = await fetch(`${BASE_URL}/community/member_activity_by_date/${query.get('community')}?startDate=${startDate}&endDate=${endDate}`, {
    //         method: "GET",
    //         headers: {
    //             "Content-Type": "application/json",
    //             "auth-token": token,
    //         },
    //     });
    //     const data = await response.json();

    //     console.log(data)
    //     if (data.success === true) {
    //         setActiveByDuration(data.response)
    //     }

    // };

    const FetchGraphData = async () => {
        // setloading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/community/analytics/content-activity/${query.get('community')}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();

        console.log(data)
        if (data.success === true) {
            setContentGraphData(data.response)
        }

    };

    const uploadLogo = async (file) => {
        if (!file) return;

        const formData = new FormData();
        formData.append("media", file);
        formData.append("community", query.get('community'))

        const token = localStorage.getItem("token");

        const res = await fetch(`${BASE_URL}/community/update-logo`, {
            method: "POST",
            headers: {
                "auth-token": token
            },
            body: formData
        });

        const data = await res.json();

        if (data.success) {
            FetchCommunityDetail()
        } else {
            alert(data.response);
        }
    };



    const deleteNoticeboardData = async (item) => {
        // setloading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/community/noticeboard/delete/${item._id}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();

        console.log(data)
        if (data.success === true) {
            const filteredList = communityDetail.noticeboardData.filter(l => l._id != item._id)
            communityDetail.noticeboardData = filteredList
            setDeleteNoticeboardPopup(false)
            setCurrentSelectedNoticeboardSlide({})
            alert("Noticeboard slide deleted")
        } else {
            alert(data.response)
        }

    };


    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:1200px)')
    const fileInputRef = useRef();

    useEffect(() => {
        async function getUserProfile() {
            const profile = localStorage.getItem("profile");
            setUserProfile(JSON.parse(profile))
        }
        getUserProfile()
        FetchCommunityDetail()
        const oldDate = new Date();
        oldDate.setDate(oldDate.getDate() - 9);
        //FetchUserGraphData(toYMD(new Date()), toYMD(oldDate))

    }, []);

    function toYMD(date) {
        const d = new Date(date);

        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    }




    if (!communityDetail.community) {

        return <>

        </>

    }


    const formatViews = (num) => {
        if (!num || num < 1000) return num?.toString() || "0";

        const units = ["K", "M", "B", "T"];
        let unitIndex = -1;

        while (num >= 1000 && unitIndex < units.length - 1) {
            num /= 1000;
            unitIndex++;
        }

        return `${num % 1 === 0 ? num : num.toFixed(1)}${units[unitIndex]}`;
    };



    return (
        <>
            <Box m={"20px"} flexDirection={'column'} display={'flex'}>
                <Box
                    display={"flex"}
                    alignItems={"center"}
                    flexDirection={'row'}
                    flexWrap={'wrap'}
                    gap={"10px"}

                >
                    <Box

                        onClick={() => {
                            if (userProfile.Role == "ADMIN") {
                                fileInputRef.current.click()
                            }
                        }}
                        sx={{
                            display: 'flex', justifyContent: 'center', alignItems: 'center',
                            position: 'relative',
                            cursor: 'pointer',
                            marginLeft: isMobileScreen ? "-8px" : "0px",
                            "&:hover .hoverView": {
                                opacity: userProfile.Role == "ADMIN" ? 1 : 0,
                                transform: "scale(1)"
                            }
                        }}>
                        <img
                            alt="profile-user"
                            width={isMobileScreen ? "90px" : "60px"}
                            height={isMobileScreen ? "90px" : "60px"}
                            src={`${communityBasics.logo}`}
                            style={{
                                cursor: "pointer", objectFit: 'cover',
                                borderRadius: "50%",
                                border: "3px solid #ffffff10"
                            }}
                        />
                        <Box
                            className="hoverView"
                            sx={{
                                position: "absolute",
                                inset: 0,
                                bgcolor: "#000000aa",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#fff",
                                fontFamily: "poppins-reg",
                                opacity: 0,
                                fontSize: "10px",
                                transform: "scale(1.1)",
                                transition: "all .2s ease"
                            }}
                        >

                            <CameraAltOutlined />

                        </Box>
                    </Box>
                    <Header
                        imgInc={true}
                        titleFontSize={isMobileScreen ? "18px" : "22px"}
                        title={`${communityBasics.title}`}
                        tag={`${communityBasics.communityType}`}
                        subtitle={`Created on ${Convert_Time_Zone(communityBasics.createdAt)}`}
                    />

                    {
                        !isMobileScreen && (
                            <Box sx={{ display: 'flex', flex: 1 }} />
                        )
                    }



                    {
                        userProfile.Role == "ADMIN" && (
                            <Box sx={{ flexDirection: 'row', alignItems: 'center', display: 'flex', gap: "10px", marginBottom: (isMobileScreen || isTabScreen) ? "0px" : "0px" }}>

                                <Box
                                    onClick={() => {
                                        setShowEditPopup(true)
                                    }}
                                    sx={{
                                        cursor: 'pointer', borderRadius: "8px", border: "1.5px solid #aaaaaa10",
                                        display: 'flex', alignItems: 'center', justifyContent: 'center', userSelect: false,
                                        paddingInline: "13px", paddingBlock: "8px", gap: "6px"
                                    }}>
                                    <EditOutlined style={{ color: "white", width: "13px", height: "13px" }} />
                                    <Typography color={"#ffffff"}
                                        fontFamily={"poppins-reg"}
                                        fontSize={"12px"} style={{ display: 'flex' }} >Edit Details</Typography>

                                </Box>



                            </Box>
                        )
                    }
                </Box>

                <Box display={"flex"} flexDirection={'column'} alignSelf={'stretch'} alignItems={'stretch'} mt={"15px"}>



                    <Box
                        display={"grid"}
                        gridTemplateColumns="repeat(12,1fr)"
                        gap="20px"
                        paddingY={"10px"}
                        pb={"10px"}>

                        <Box
                            // key={`${transaction.txId}-${i}`}
                            gridColumn={isMobileScreen ? "span 12" : isTabScreen ? "span 6" : "span 4"}
                            gridRow="span 4"
                            display="flex"
                            px="15px"
                            component={Link}
                            py={"8px"}
                            to={{
                                pathname: "/admin/communitymembers",
                                search: `?community=${communityBasics._id}`,
                                state: { fromDashboard: true },
                                // console.log(first)
                            }}
                            sx={{
                                cursor: 'pointer',
                                borderRadius: "20px",
                                border: "1.7px solid transparent",
                                background:
                                    "linear-gradient(#ffffff00 0 0) padding-box, linear-gradient(#0b0b0f 0 0) padding-box, linear-gradient(45deg,#943bff, rgba(214, 152, 36, 1)) border-box",
                                textDecoration: 'none', paddingY: "25px", flexDirection: 'column',
                                display: 'flex',
                            }}>


                            <Box sx={{
                                marginInline: "10px", display: 'flex', flexDirection: 'row',
                                alignItems: 'center'
                            }}>
                                <Typography fontSize={"17px"} fontFamily={'poppins-reg'} color={"#ffffff"}
                                    display={'flex'} flex={1}
                                >
                                    Community Performance
                                </Typography>

                                <ArrowOutwardRounded style={{ color: "#ffffff" }} />

                            </Box>
                            <Typography fontFamily={'poppins-reg'} color={"#3bff4bff"}
                                style={{
                                    background: "#3bff7c10", borderRadius: "5px", border: "1px solid #41ff3b30", paddingBlock: "2px",
                                    paddingInline: "8px", fontSize: "11px", marginLeft: "10px", alignSelf: 'flex-start', marginTop: "2px"
                                }}
                            >
                                Members
                            </Typography>


                            <Box sx={{ flexDirection: 'row', display: 'flex', marginInline: "10px", marginBlock: "15px" }}>


                                <Box sx={{
                                    flex: 1.4, flexDirection: 'column', display: 'flex',
                                }}>

                                    <Box sx={{ flexDirection: 'row', alignItems: 'center', m: "8px 0 0 0", display: 'flex' }}>
                                        <Typography
                                            variant={(isMobileScreen || isTabScreen) ? "h3" : "h2"}
                                            color={colors.grey[100]}
                                            fontFamily={"poppins-bold"}
                                        >
                                            {`${communityDetail.totalMembers}`}
                                        </Typography>

                                        {
                                            communityDetail.todayJoined != 0 && (
                                                <Box sx={{
                                                    flexDirection: 'row', alignItems: 'center', m: "0 0 0 10px", display: 'flex', justifyItems: 'center', justifyContent: 'center',
                                                    alignContent: 'center'
                                                }}>
                                                    <MovingRounded sx={{ color: "lime", fontSize: "15.5px" }} />
                                                    <Typography
                                                        fontSize={"10.5px"}
                                                        color={'lime'}
                                                        fontFamily={"poppins-reg"}
                                                        gutterBottom={false}
                                                        ml={"3px"}
                                                    >+{communityDetail.todayJoined < 10 ? `0${communityDetail.todayJoined}` : `${communityDetail.todayJoined}`} today</Typography>
                                                </Box>
                                            )
                                        }
                                    </Box>
                                    <Typography fontSize={"12px"} fontFamily={'poppins-reg'} color={"#ffffff50"}
                                        display={'flex'} flex={1}
                                    >
                                        Total Members
                                    </Typography>

                                </Box>
                                <Box sx={{ width: "1.5px", background: "#ffffff10", marginBlock: "5px" }} />
                                <Box sx={{
                                    flex: 1, flexDirection: 'column', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>

                                    <Box sx={{ flexDirection: 'row', alignItems: 'center', m: "8px 0 0 0", display: 'flex' }}>
                                        <Typography
                                            variant={(isMobileScreen || isTabScreen) ? "h3" : "h2"}
                                            color={colors.grey[100]}
                                            fontFamily={"poppins-bold"}
                                        >
                                            {`${communityDetail.activeToday ?? 0}`}
                                        </Typography>


                                    </Box>
                                    <Typography fontSize={"12px"} fontFamily={'poppins-reg'} color={"#ffffff50"}
                                        display={'flex'} flex={1}
                                    >
                                        Active Today
                                    </Typography>

                                </Box>


                            </Box>

                            <Box sx={{
                                flexDirection: 'row', display: 'flex', paddingLeft: "25px", paddingTop: "15px", mt: "5px",
                                alignItems: 'flex-end', borderTop: "1px solid #aaaaaa10"
                            }}>

                                <Box sx={{ flexDirection: 'row', alignItems: 'center', display: 'flex', flex: 1 }}>

                                    {
                                        (communityDetail?.memberList ?? [])
                                            .concat([formatViews(communityDetail?.totalMembers || 0)])
                                            .map((it, index) => (
                                                <Box
                                                    sx={{
                                                        display: 'flex', justifyContent: 'center', alignItems: 'center',
                                                        position: 'relative',
                                                        cursor: 'pointer',

                                                    }}>

                                                    {
                                                        index != 3 ? (
                                                            <img
                                                                alt="profile-user"
                                                                width="50px"
                                                                height="50px"
                                                                src={`${it.image[0] ?? ""}`}
                                                                style={{
                                                                    cursor: "pointer", objectFit: 'cover',
                                                                    borderRadius: "50%",
                                                                    marginLeft: "-20px",
                                                                    background: "#0f0f0f",
                                                                    border: "2px solid #1d1d1dff"
                                                                }}
                                                            />
                                                        ) : (
                                                            <Box sx={{
                                                                width: "50px", height: "50px", borderRadius: "50%",
                                                                marginLeft: "-20px",
                                                                background:
                                                                    "linear-gradient(#0f0f0f 0 0) padding-box, linear-gradient(#0b0b0f 0 0) padding-box, linear-gradient(45deg,#943bff, #34636900) border-box",

                                                                border: index == 3 ? "2px solid transparent" : "2px solid #1d1d1dff",
                                                                color: "#ffffff",
                                                                fontFamily: "poppins-mid",
                                                                fontSize: "13px",
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                display: 'flex'

                                                            }} >{it}</Box>
                                                        )
                                                    }


                                                </Box>
                                            ))
                                    }

                                    <Box sx={{ flex: '1', display: 'flex' }} />

                                    <Box sx={{
                                        background:
                                            "linear-gradient(#0f0f0f 0 0) padding-box, linear-gradient(#0b0b0f 0 0) padding-box, linear-gradient(45deg,#943bff, rgba(214, 152, 36, 1)) border-box",

                                        border: "1px solid transparent",
                                        color: "#ffffff",
                                        fontFamily: "poppins-reg",
                                        fontSize: "13px",
                                        paddingBlock: "5px",
                                        paddingInline: "10px",
                                        marginRight: "15px",
                                        borderRadius: "5px",
                                        alignItems: 'center',
                                        marginTop: "10px",
                                        justifyContent: 'center',
                                        display: 'flex'

                                    }}>

                                        View Details

                                    </Box>

                                </Box>



                            </Box>

                        </Box>

                        <Box
                            gridColumn={isMobileScreen ? "span 12" : isTabScreen ? "span 6" : "span 3"}
                            gridRow="span 4"
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: "20px"
                            }} >
                            <Box
                                // key={`${transaction.txId}-${i}`}

                                display="flex"
                                alignItems="center"
                                px="15px"
                                py={"8px"}
                                target={"_blank"}
                                sx={{
                                    background: "#ffffff08",
                                    borderRadius: "20px",
                                    border: "1.5px solid #aaaaaa05",
                                    textDecoration: 'none', paddingY: "20px", flexDirection: 'row',
                                    display: 'flex', flex: 1
                                }}
                            >

                                <Box sx={{ flex: 1, flexDirection: 'column', display: 'flex', marginLeft: "10px" }}>

                                    <Typography fontSize={"15px"} fontFamily={'poppins-reg'} color={"#ffffff"}>
                                        Community Admins
                                    </Typography>

                                    <Box sx={{
                                        flexDirection: 'row', alignItems: 'center', display: 'flex', marginLeft: "13px",
                                        marginTop: "15px"
                                    }}>

                                        {
                                            (communityBasics?.admins ?? [])
                                                .slice(0, 3)
                                                .concat(
                                                    (communityBasics?.admins?.length || 0) > 3
                                                        ? [`${communityBasics.admins.length}`]
                                                        : []
                                                )
                                                .map((it, index) => (
                                                    <Box
                                                        sx={{
                                                            display: 'flex', justifyContent: 'center', alignItems: 'center',
                                                            position: 'relative',
                                                            cursor: 'pointer',

                                                        }}>

                                                        {
                                                            (index != 3 && it) ? (
                                                                <img
                                                                    alt="profile-user"
                                                                    width="40px"
                                                                    height="40px"
                                                                    src={`${it.image[0] ?? ""}`}
                                                                    style={{
                                                                        cursor: "pointer", objectFit: 'cover',
                                                                        borderRadius: "50%",
                                                                        marginLeft: "-15px",
                                                                        background: "#0f0f0f",
                                                                        border: "2px solid #1d1d1dff"
                                                                    }}
                                                                />
                                                            ) : (
                                                                <>
                                                                    {
                                                                        it && (
                                                                            <Box sx={{
                                                                                width: "40px", height: "40px", borderRadius: "50%",
                                                                                marginLeft: "-20px",
                                                                                background:
                                                                                    "linear-gradient(#0f0f0f 0 0) padding-box, linear-gradient(#0b0b0f 0 0) padding-box, linear-gradient(45deg,#943bff, #34636900) border-box",

                                                                                border: index == 3 ? "2px solid transparent" : "2px solid #1d1d1dff",
                                                                                color: "#ffffff",
                                                                                fontFamily: "poppins-mid",
                                                                                fontSize: "12px",
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                display: 'flex'

                                                                            }} >{it}</Box>
                                                                        )
                                                                    }
                                                                </>


                                                            )
                                                        }


                                                    </Box>
                                                ))
                                        }

                                        <Box sx={{ flex: '1', display: 'flex' }} />

                                        <Box sx={{
                                            background:
                                                "linear-gradient(#ffffff10 0 0) padding-box, linear-gradient(#0b0b0f 0 0) padding-box, linear-gradient(180deg,#943bff, rgba(34, 34, 34, 1)) border-box",
                                            border: "1px solid transparent",
                                            color: "#ffffff",
                                            fontFamily: "poppins-reg",
                                            fontSize: "12px",
                                            paddingBlock: "5px",
                                            paddingInline: "10px",
                                            marginRight: "10px",
                                            borderRadius: "5px",
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            display: 'flex'

                                        }}>

                                            Manage Admins

                                        </Box>

                                    </Box>



                                </Box>

                            </Box>
                            <Box

                                display="flex"
                                alignItems="center"
                                px="15px"
                                py={"8px"}
                                target={"_blank"}
                                sx={{
                                    background: "#ffffff08",
                                    borderRadius: "20px",
                                    border: "1.5px solid #aaaaaa05",
                                    textDecoration: 'none', paddingY: "20px", flexDirection: 'row',
                                    display: 'flex', flex: 1
                                }}
                            >

                                <Box sx={{ flex: 1, flexDirection: 'column', display: 'flex', marginLeft: "10px" }}>

                                    <Typography fontSize={"15px"} fontFamily={'poppins-reg'} color={"#ffffff"}>
                                        Auto-Follow Accounts
                                    </Typography>

                                    <Box sx={{
                                        flexDirection: 'row', alignItems: 'center', display: 'flex', marginLeft: "13px",
                                        marginTop: "15px"
                                    }}>

                                        {
                                            (communityBasics?.autoFollow ?? [])
                                                .slice(0, 3)
                                                .concat(
                                                    (communityBasics?.autoFollow?.length || 0) > 3
                                                        ? [`${communityBasics.autoFollow.length}`]
                                                        : []
                                                )
                                                .map((it, index) => (
                                                    <Box
                                                        sx={{
                                                            display: 'flex', justifyContent: 'center', alignItems: 'center',
                                                            position: 'relative',
                                                            cursor: 'pointer',

                                                        }}>

                                                        {
                                                            (index != 3 && it) ? (
                                                                <img
                                                                    alt="profile-user"
                                                                    width="40px"
                                                                    height="40px"
                                                                    src={`${it.image[0] ?? ""}`}
                                                                    style={{
                                                                        cursor: "pointer", objectFit: 'cover',
                                                                        borderRadius: "50%",
                                                                        marginLeft: "-15px",
                                                                        background: "#0f0f0f",
                                                                        border: "2px solid #1d1d1dff"
                                                                    }}
                                                                />
                                                            ) : (
                                                                <>
                                                                    {
                                                                        it && (
                                                                            <Box sx={{
                                                                                width: "40px", height: "40px", borderRadius: "50%",
                                                                                marginLeft: "-20px",
                                                                                background:
                                                                                    "linear-gradient(#0f0f0f 0 0) padding-box, linear-gradient(#0b0b0f 0 0) padding-box, linear-gradient(45deg,#943bff, #34636900) border-box",

                                                                                border: index == 3 ? "2px solid transparent" : "2px solid #1d1d1dff",
                                                                                color: "#ffffff",
                                                                                fontFamily: "poppins-mid",
                                                                                fontSize: "12px",
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                display: 'flex'

                                                                            }} >{it}</Box>
                                                                        )
                                                                    }
                                                                </>


                                                            )
                                                        }


                                                    </Box>
                                                ))
                                        }

                                        <Box sx={{ flex: '1', display: 'flex' }} />

                                        <Box sx={{
                                            background:
                                                "linear-gradient(#ffffff10 0 0) padding-box, linear-gradient(#0b0b0f 0 0) padding-box, linear-gradient(180deg,#943bff, rgba(34, 34, 34, 1)) border-box",

                                            border: "1px solid transparent",
                                            color: "#ffffff",
                                            fontFamily: "poppins-reg",
                                            fontSize: "12px",
                                            paddingBlock: "5px",
                                            paddingInline: "10px",
                                            marginRight: "10px",
                                            borderRadius: "5px",
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            display: 'flex'

                                        }}>

                                            Manage Accounts

                                        </Box>

                                    </Box>



                                </Box>

                            </Box>

                        </Box>

                        <Box
                            gridColumn={isMobileScreen ? "span 12" : isTabScreen ? "span 6" : "span 5"}
                            gridRow="span 4"
                            px={"20px"}
                            sx={{
                                background: "#ffffff08",
                                borderRadius: "20px",
                                border: "1.5px solid #aaaaaa05",
                                textDecoration: 'none', paddingY: "20px", flexDirection: 'column',
                            }} >

                            <Typography fontSize={"15px"} fontFamily={'poppins-reg'} color={"#ffffff"}
                                display={'flex'} flex={1}
                            >
                                About the communtiy
                            </Typography>

                            <Box sx={{ height: "1px", background: "#aaaaaa10", marginTop: "15px", marginBottom: "15px" }} />


                            <Box sx={{ flexDirection: 'row', display: 'flex', }} >

                                <Box sx={{ flexDirection: "column", display: 'flex', flex: 1.6 }}>



                                    <Typography fontSize={"11.5px"} fontFamily={'poppins-reg'} color={"#ffffff80"}
                                        display={'flex'}
                                    >
                                        Display Name
                                    </Typography>


                                    <Typography fontSize={"13px"} fontFamily={'poppins-reg'} color={"#ffffff"}
                                        display={'flex'}
                                    >
                                        {communityBasics.name ? communityBasics.name : "-"}
                                    </Typography>

                                    <Typography fontSize={"11.5px"} fontFamily={'poppins-reg'} color={"#ffffff80"}
                                        display={'flex'} mt={"15px"}
                                    >
                                        Community Tag
                                    </Typography>


                                    <Typography fontSize={"13px"} fontFamily={'poppins-reg'} color={"#ffffff"}
                                        display={'flex'}
                                    >
                                        {communityBasics.tag ? communityBasics.tag : "-"}
                                    </Typography>

                                    <Typography fontSize={"11.5px"} fontFamily={'poppins-reg'} color={"#ffffff80"}
                                        display={'flex'} mt={"15px"}
                                    >
                                        Allowed Domains
                                    </Typography>

                                    <Box sx={{
                                        flexDirection: 'row', display: 'flex', alignItems: "center", gap: "5px", marginTop: "5px",
                                        flexWrap: 'wrap'
                                    }} >

                                        {
                                            communityBasics.allowedDomains.map((item, index) => (
                                                <Typography fontSize={"13px"} fontFamily={'poppins-reg'} color={"#ffffff"}
                                                    style={{ background: "#ffffff10", borderRadius: "100px", paddingInline: "10px", paddingBlock: "4px" }}
                                                >{item}</Typography>
                                            ))
                                        }

                                    </Box>


                                </Box>

                                <Box sx={{ flexDirection: "column", display: 'flex', flex: 1 }}>



                                    <Typography fontSize={"11.5px"} fontFamily={'poppins-reg'} color={"#ffffff80"}
                                        display={'flex'}
                                    >
                                        Paid Community
                                    </Typography>


                                    <Typography fontSize={"13px"} fontFamily={'poppins-reg'} color={"#ffffff"}
                                        display={'flex'}
                                    >
                                        {communityBasics.planId ? "Yes" : "No"}
                                    </Typography>

                                    <Typography fontSize={"11.5px"} fontFamily={'poppins-reg'} color={"#ffffff80"}
                                        display={'flex'} mt={"15px"}
                                    >
                                        Approval Required
                                    </Typography>


                                    <Typography fontSize={"13px"} fontFamily={'poppins-reg'} color={"#ffffff"}
                                        display={'flex'}
                                    >
                                        {communityBasics.approvalRequired ? "true" : "false"}
                                    </Typography>

                                    <Typography fontSize={"11.5px"} fontFamily={'poppins-reg'} color={"#ffffff80"}
                                        display={'flex'} mt={"20px"}
                                    >
                                        Community Location
                                    </Typography>
                                    <Box
                                        onClick={() => {
                                            const url = `https://www.google.com/maps?q=${communityBasics?.locationCoordinates?.latitude ?? 0},${communityBasics?.locationCoordinates?.longitude ?? 0}`;
                                            window.open(url, "_blank");
                                        }}
                                        sx={{
                                            flexDirection: 'row', display: 'flex', alignItems: "center", gap: "5px", marginTop: "0px",
                                            cursor: 'pointer'
                                        }} >
                                        <Typography fontSize={"13px"} fontFamily={'poppins-reg'} color={"#943bff"}
                                            display={'flex'}
                                        >
                                            open in map
                                        </Typography>
                                        <ArrowOutward style={{ color: "#943bff", fontSize: "16px" }} />
                                    </Box>




                                </Box>

                            </Box>



                        </Box>


                        <Box
                            // key={`${transaction.txId}-${i}`}
                            gridColumn={(isMobileScreen || isTabScreen) ? "span 12" : "span 7"}
                            gridRow="span 4"
                            display="flex"
                            alignItems="center"
                            px="15px"
                            py={"8px"}
                            target={"_blank"}
                            sx={{
                                background: "#ffffff08",
                                borderRadius: "20px",
                                border: "1.5px solid #aaaaaa05",
                                textDecoration: 'none', paddingY: "20px", flexDirection: (isMobileScreen || isTabScreen) ? 'column' : 'row',
                                display: 'flex', position: 'relative'

                            }}>

                            <Box sx={{
                                flex: (isMobileScreen || isTabScreen) ? undefined : 1, display: 'flex', flexDirection: 'column', height: (isMobileScreen || isTabScreen) ? "300px" : "400px", marginBottom: "40px",
                                width: (isMobileScreen || isTabScreen) ? "100%" : "82%",
                            }}>

                                <Typography fontSize={"17px"} fontFamily={'poppins-reg'} color={"#ffffff"}
                                    display={'flex'} style={{ marginInline: "10px" }}
                                >
                                    Community Content Flow
                                </Typography>

                                <ResponsiveLine
                                    data={contentGraphData}
                                    margin={{ top: 40, right: (isMobileScreen || isTabScreen) ? 20 : 30, bottom: 40, left: (isMobileScreen || isTabScreen) ? 30 : 40 }}
                                    xScale={{ type: "point" }}
                                    yScale={{
                                        type: "linear", min: 0, max: "auto", stacked: false, nice: true,
                                        tickValues: "auto"
                                    }}

                                    curve={'catmullRom'}

                                    axisBottom={{
                                        tickPadding: (isMobileScreen || isTabScreen) ? 5 : 15,
                                        tickRotation: (isMobileScreen || isTabScreen) ? -45 : 0,
                                        tickLabelStyle: {
                                            fill: "#ffffff50",
                                            fontSize: 11,
                                            fontFamily: "poppins-reg"
                                        }
                                    }}

                                    axisLeft={{
                                        tickPadding: 15,
                                        legend: "",
                                        legendOffset: -50,
                                        legendPosition: "middle",
                                        format: v => Number.isInteger(v) ? v : "",
                                        tickLabelStyle: {
                                            fill: "#ffffff60",
                                            fontSize: 11,
                                            fontFamily: "poppins-reg"
                                        }
                                    }}

                                    defs={[
                                        linearGradientDef('pg', [
                                            { offset: 0, color: '#ff6b00', opacity: 0.95 },
                                            { offset: 70, color: '#ff6b00', opacity: 0.30 },
                                            { offset: 100, color: '#ff6b00', opacity: 0 }
                                        ]),
                                        linearGradientDef('gg', [
                                            { offset: 0, color: '#00ffd5', opacity: 0.95 },
                                            { offset: 70, color: '#00ffd5', opacity: 0.30 },
                                            { offset: 100, color: '#00ffd5', opacity: 0 }
                                        ]),
                                        linearGradientDef('cg', [
                                            { offset: 0, color: '#b44cff', opacity: 0.95 },
                                            { offset: 70, color: '#b44cff', opacity: 0.30 },
                                            { offset: 100, color: '#b44cff', opacity: 0 }
                                        ]),
                                        linearGradientDef('plg', [
                                            { offset: 0, color: '#ff3cac', opacity: 0.95 },
                                            { offset: 70, color: '#ff3cac', opacity: 0.30 },
                                            { offset: 100, color: '#ff3cac', opacity: 0 }
                                        ]),
                                        linearGradientDef('bg', [
                                            { offset: 0, color: '#ffb300', opacity: 0.95 },
                                            { offset: 70, color: '#ffb300', opacity: 0.30 },
                                            { offset: 100, color: '#ffb300', opacity: 0 }
                                        ]),
                                    ]}

                                    fill={[
                                        { match: { id: 'Posts' }, id: 'pg' },
                                        { match: { id: 'Gossips' }, id: 'gg' },
                                        { match: { id: 'Reels' }, id: 'cg' },
                                        { match: { id: 'Polls' }, id: 'plg' },
                                        { match: { id: 'Blogs' }, id: 'bg' }
                                    ]}


                                    enableGridX={false}
                                    enableGridY={true}

                                    theme={{
                                        background: "transparent",
                                        textColor: "#ffffff90",
                                        fontFamily: "poppins-reg",
                                        grid: {
                                            line: {
                                                stroke: "#ffffff15",
                                                strokeWidth: 1,
                                                strokeDasharray: "5 5"
                                            },

                                        },

                                        tooltip: {
                                            container: {
                                                background: "#0f0f0f",
                                                color: "#fff",
                                                borderRadius: 10,
                                                border: "2px solid #aaaaaa10",
                                                fontSize: "11px",
                                                fontFamily: "poppins-reg"
                                            }
                                        }
                                    }}

                                    colors={[
                                        "#ff6b00",
                                        "#00ffd5",
                                        "#b44cff",
                                        "#ff3cac",
                                        "#ffb300"
                                    ]}

                                    lineWidth={1.5}
                                    enableArea={true}
                                    areaOpacity={0.06}

                                    pointSize={3}
                                    pointBorderWidth={0.5}
                                    pointBorderColor="#ffffff"

                                    enablePointLabel={false}

                                    useMesh={true}
                                    enableTouchCrosshair={true}

                                    motionConfig="gentle"

                                />


                            </Box>

                            <Box sx={{ flexDirection: (isMobileScreen || isTabScreen) ? 'row' : 'column', flexWrap: 'wrap', display: 'flex', width: (isMobileScreen || isTabScreen) ? "auto" : "18%", gap: "10px" }}>

                                {
                                    [{ title: "Posts", color: "#ff6b00", count: communityDetail.posts ?? 0, todayCount: communityDetail.postsToday ?? 0 },
                                    { title: "Crisps", color: "#b44cff", count: communityDetail.crisps ?? 0, todayCount: communityDetail.crispsToday ?? 0 },
                                    { title: "Gossips", color: "#00ffd5", count: communityDetail.gossips ?? 0, todayCount: communityDetail.gossipsToday ?? 0 },
                                    { title: "Polls", color: "#ff3cac", count: communityDetail.polls ?? 0, todayCount: communityDetail.pollsToday ?? 0 },
                                    { title: "Blogs", color: "#ffb300", count: communityDetail.blogs ?? 0, todayCount: communityDetail.blogsToday ?? 0 },
                                    ].map((item, index) => (
                                        <Box sx={{
                                            flex: 1, flexDirection: 'column', display: 'flex', minWidth: (isMobileScreen || isTabScreen) ? "35%" : "auto",
                                            background: "#aaaaaa10", py: "10px", borderRadius: "15px", paddingInline: "15px"
                                        }}>

                                            <Box sx={{ flexDirection: 'row', display: 'flex', alignItems: 'center', gap: "5px" }}>

                                                <Box sx={{ width: "14px", height: "14px", background: item.color, borderRadius: "3px" }} />
                                                <Typography fontSize={"13px"} fontFamily={'poppins-reg'} color={"#ffffff50"}
                                                    display={'flex'}
                                                >{item.title}</Typography>

                                            </Box>

                                            <Box sx={{ flexDirection: 'row', alignItems: 'center', display: 'flex' }}>
                                                <Typography
                                                    fontSize={(isMobileScreen || isTabScreen) ? "15px" : "15px"}
                                                    color={colors.grey[100]}
                                                    fontFamily={"poppins-bold"}
                                                >
                                                    {formatViews(item.count ?? 0)}
                                                </Typography>

                                                {
                                                    (item.todayCount ?? 0) > 0 && (
                                                        <Box sx={{
                                                            display: 'flex', flexDirection: 'row', gap: "4px", alignItems: 'center', background: "#03fc0b15",
                                                            marginLeft: "10px", paddingInline: "6px", paddingBlock: "2px", borderRadius: "3px",
                                                            border: `0px solid ${"#03fc0b20"}`
                                                        }}>

                                                            <Typography sx={{ fontSize: "10px", fontFamily: 'poppins-reg', color: "#03fc0b" }}>
                                                                {item.todayCount} Today
                                                            </Typography>
                                                        </Box>
                                                    )
                                                }


                                            </Box>


                                        </Box>
                                    ))
                                }



                            </Box>




                        </Box>
                        {
                            communityDetail.noticeboardData && (
                                <Box
                                    // key={`${transaction.txId}-${i}`}
                                    gridColumn={(isMobileScreen || isTabScreen) ? "span 12" : 'span 5'}
                                    gridRow="span 4"
                                    display={'grid'}
                                    alignItems="center"
                                    px="15px"
                                    pt={"15px"}
                                    pb={"10px"}
                                    sx={{
                                        background: "#ffffff08",
                                        borderRadius: "20px",
                                        border: "1.5px solid #aaaaaa05",
                                        textDecoration: 'none', flexDirection: 'column',
                                    }}>


                                    <Box sx={{
                                        flexDirection: 'row', alignItems: 'center', display: 'flex',
                                        marginInline: "10px", flexWrap: "wrap", gap: "10px"
                                    }}>

                                        <Box sx={{
                                            display: 'flex', flexDirection: 'row', alignItems: 'center',
                                            flex: 1, gap: "6px"
                                        }}>
                                            <Typography style={{
                                                fontFamily: "poppins-reg", fontSize: "15px",
                                                color: "#ffffff",
                                            }} >Noticeboard</Typography>

                                            <Typography style={{
                                                fontFamily: "poppins-reg", fontSize: "11px",
                                                color: "#ffffff", background: "#ffffff10",
                                                borderRadius: "100px", paddingInline: "8px", paddingBlock: "3px"
                                            }} >{communityDetail.noticeboardData.length} Slides</Typography>


                                        </Box>


                                        <Box sx={{ flexDirection: "row", alignItems: "center", display: "flex" }} >
                                            <Typography onClick={() => {
                                                navigate(`/admin/noticeboard?community=${query.get("community")}`)
                                            }}
                                                sx={{
                                                    cursor: 'pointer'
                                                }}
                                                style={{
                                                    fontFamily: "poppins-reg", fontSize: isMobileScreen ? "11px" : "13px",
                                                    color: "#ffffff", paddingInline: "15px",
                                                    background: "linear-gradient(#ffffff10 0 0) padding-box, linear-gradient(#0b0b0f 0 0) padding-box, linear-gradient(180deg,#943bff, rgba(34, 34, 34, 1)) border-box",

                                                    paddingBlock: "5px",
                                                    borderRadius: "3px", border: "1px solid #ffffff00",
                                                    marginRight: "10px",

                                                }} >Rearrange</Typography>

                                            <Typography onClick={() => {
                                                setOpenNoticeBoardForm(true)
                                            }}
                                                sx={{
                                                    cursor: 'pointer'
                                                }}
                                                style={{
                                                    fontFamily: "poppins-reg", fontSize: isMobileScreen ? "11px" : "13px",
                                                    color: "#ffffff", paddingInline: "15px",
                                                    background: "linear-gradient(#ffffff10 0 0) padding-box, linear-gradient(#0b0b0f 0 0) padding-box, linear-gradient(180deg,#943bff, rgba(34, 34, 34, 1)) border-box",

                                                    paddingBlock: "5px",
                                                    borderRadius: "3px", border: "1px solid #ffffff00",
                                                    marginRight: "2px",

                                                }} >Add New</Typography>

                                        </Box>




                                    </Box>

                                    <Box sx={{ height: "1px", background: "#aaaaaa10", marginBlock: '15px' }} />

                                    {
                                        communityDetail.noticeboardData.length > 0 && (

                                            <Box sx={{ flexDirection: 'column', display: 'flex', aspectRatio: 16 / 9 }}>

                                                <CustomCarousel
                                                    data={communityDetail.noticeboardData}
                                                    onReplace={(item) => {
                                                        setNoticeboardSlideToReplace(item)
                                                        setOpenNoticeBoardReplaceForm(true)
                                                    }}
                                                    onDelete={(item) => {
                                                        setCurrentSelectedNoticeboardSlide(item)
                                                        setDeleteNoticeboardPopup(true)
                                                    }} >
                                                    {
                                                        communityDetail.noticeboardData.map((item, index) => {
                                                            return <Box sx={{ display: 'flex' }}>
                                                                <img alt={'noticeboard_banner'} src={item.mediaUrl} />


                                                                <Box sx={{
                                                                    display: 'flex', position: 'absolute', background: '#0f0f0f', borderRadius: 100,
                                                                    margin: "10px", alignItems: 'center', justifyContent: 'center',
                                                                    alignContent: 'center', justifyItems: 'center', width: "30px", height: "30px"
                                                                }}>
                                                                    <Typography style={{ color: "#ffffff", fontFamily: "poppins-mid", fontSize: "12px" }}>{item.position}</Typography>
                                                                </Box>


                                                            </Box>
                                                        })
                                                    }

                                                </CustomCarousel>
                                            </Box>

                                        )
                                    }

                                </Box>
                            )
                        }


                    </Box>

                    <Box
                        display={"grid"}
                        gridTemplateColumns="repeat(12,1fr)"
                        gap="20px"
                        paddingY={"15px"}
                        pb={"20px"}>


                        <Box
                            // key={`${transaction.txId}-${i}`}
                            gridColumn={(isMobileScreen || isTabScreen) ? 'span 12' : 'span 5'}
                            gridRow="span 1"
                            px="25px"
                            py={"15px"}
                            sx={{
                                background: "#ffffff08",
                                borderRadius: "20px",
                                border: "1.5px solid #aaaaaa05",
                                textDecoration: 'none', flexDirection: 'column',
                            }}>



                            <Typography style={{ fontFamily: "poppins-reg", fontSize: "16px", color: "#ffffff", marginTop: "10px" }} >Marketplace Details</Typography>

                            <Box sx={{ height: "1px", background: '#aaaaaa10', marginTop: "15px" }} />

                            <Box
                                display={'grid'}
                                mt={"20px"}
                                gridTemplateColumns="repeat(12,1fr)"
                                gap={"20px"}
                            >



                                <Box
                                    // key={`${transaction.txId}-${i}`}
                                    gridColumn={isMobileScreen ? "span 6" : "span 4"}
                                    display="flex"
                                    px="10px"
                                    py={"8px"}
                                    target={"_blank"}
                                    sx={{
                                        background: "#ffffff08",
                                        borderRadius: "20px",
                                        border: "1.5px solid #ffffff00",
                                        textDecoration: 'none', paddingY: "15px", flexDirection: 'row',
                                        display: 'flex',
                                    }}
                                >

                                    <Box sx={{ flex: 1, flexDirection: 'column', display: 'flex', marginLeft: "10px" }}>

                                        <Typography fontSize={"12px"} fontFamily={'poppins-reg'} color={colors.grey[300]}>
                                            Products
                                        </Typography>

                                        <Box sx={{ flexDirection: 'row', alignItems: 'center', m: "2px 0 0 0", display: 'flex' }}>
                                            <Typography
                                                variant={(isMobileScreen || isTabScreen) ? "h5" : "h4"}
                                                color={colors.grey[100]}
                                                fontFamily={"poppins-bold"}
                                            >
                                                {`${communityDetail.products}`}
                                            </Typography>


                                        </Box>


                                    </Box>

                                </Box>

                                <Box
                                    // key={`${transaction.txId}-${i}`}
                                    gridColumn={isMobileScreen ? "span 6" : "span 4"}
                                    display="flex"
                                    px="10px"
                                    py={"8px"}
                                    target={"_blank"}
                                    sx={{
                                        background: "#ffffff08",
                                        borderRadius: "20px",
                                        border: "1.5px solid #ffffff00",
                                        textDecoration: 'none', paddingY: "15px", flexDirection: 'row',
                                        display: 'flex',
                                    }}
                                >

                                    <Box sx={{ flex: 1, flexDirection: 'column', display: 'flex', marginLeft: "10px" }}>

                                        <Typography fontSize={"12px"} fontFamily={'poppins-reg'} color={colors.grey[300]}>
                                            Services
                                        </Typography>

                                        <Box sx={{ flexDirection: 'row', alignItems: 'center', m: "2px 0 0 0", display: 'flex' }}>
                                            <Typography
                                                variant={(isMobileScreen || isTabScreen) ? "h5" : "h4"}
                                                color={colors.grey[100]}
                                                fontFamily={"poppins-bold"}
                                            >
                                                {`${communityDetail.services}`}
                                            </Typography>

                                        </Box>


                                    </Box>

                                </Box>

                                <Box
                                    // key={`${transaction.txId}-${i}`}
                                    gridColumn={isMobileScreen ? "span 12" : "span 4"}
                                    display="flex"
                                    px="10px"
                                    py={"8px"}
                                    target={"_blank"}
                                    sx={{
                                        background: "#ffffff08",
                                        borderRadius: "20px",
                                        border: "1.5px solid #ffffff00",
                                        textDecoration: 'none', paddingY: "15px", flexDirection: 'row',
                                        display: 'flex',
                                    }}
                                >

                                    <Box sx={{ flex: 1, flexDirection: 'column', display: 'flex', marginLeft: "10px" }}>

                                        <Typography fontSize={"12px"} fontFamily={'poppins-reg'} color={colors.grey[300]}>
                                            Collaborations
                                        </Typography>

                                        <Box sx={{ flexDirection: 'row', alignItems: 'center', m: "2px 0 0 0", display: 'flex' }}>
                                            <Typography
                                                variant={(isMobileScreen || isTabScreen) ? "h5" : "h4"}
                                                color={colors.grey[100]}
                                                fontFamily={"poppins-bold"}
                                            >
                                                {`${communityDetail.collab}`}
                                            </Typography>


                                        </Box>


                                    </Box>

                                </Box>


                                {
                                    communityDetail.marketplaceAds && (
                                        <Box
                                            // key={`${transaction.txId}-${i}`}
                                            gridColumn={'span 12'}
                                            gridRow={'span 1'}
                                            display={'grid'}
                                            sx={{
                                                borderRadius: "20px",
                                                textDecoration: 'none', flexDirection: 'column',
                                            }}>

                                            {
                                                communityDetail.marketplaceAds.length > 0 && (
                                                    <CustomCarousel onReplace={() => { }} onDelete={() => {

                                                    }} data={communityDetail.marketplaceAds} marginTop="0px">
                                                        {
                                                            communityDetail.marketplaceAds.map((item, index) => {
                                                                return <img alt={'marketplace_banner'} src={item.banner} />
                                                            })
                                                        }
                                                    </CustomCarousel>
                                                )
                                            }

                                        </Box>
                                    )
                                }

                            </Box>



                        </Box>



                    </Box>


                </Box>


                <CommunityNotificationSendPopup community={communityBasics} open={showNotificationShowPopup} onClose={() => {
                    setShowNotificationShowPopup(false)
                }} />

                <MultiPartFormPopup open={openNoticeboardForm}

                    onCompleted={() => {
                        setOpenNoticeBoardForm(false)
                        FetchCommunityDetail()
                    }}
                    onClose={() => setOpenNoticeBoardForm(false)} community={communityBasics._id} communityName={communityBasics.title}

                    creators={[{ name: "Buzzonspot", id: 123 }]} />


                {
                    noticeboardSlideToReplace._id && (
                        <MultiPartNoticeboardReplacePopup
                            onCompleted={() => {
                                setOpenNoticeBoardReplaceForm(false)
                                FetchCommunityDetail()
                            }}
                            open={openNoticeboardReplaceForm}
                            onClose={() => setOpenNoticeBoardReplaceForm(false)}
                            slideData={noticeboardSlideToReplace}
                        />
                    )
                }

                <PopupDeleteConfirmation onDelete={(item) => {
                    deleteNoticeboardData(item)
                }} data={currentSelectedNoticeboardSlide} isNoticeboard={true} open={openDeleteNoticeboardPopup} onClose={() => {
                    setDeleteNoticeboardPopup(false)
                    setCurrentSelectedNoticeboardSlide({})
                }} />

                <EditCommunityPopup
                    data={communityBasics}
                    open={showEditPopup}
                    onClose={() => setShowEditPopup(false)}
                    onComplete={() => {
                        setShowEditPopup(false)
                        FetchCommunityDetail()
                    }}
                />

                <input
                    type="file"
                    accept="image/*"
                    hidden
                    ref={fileInputRef}
                    onChange={(e) => uploadLogo(e.target.files[0])}
                />

            </Box>
        </>
    );
};



export default CommunityDetail;
